import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const SfChevronForwardCircleIcon = (props: IconProps) => {
  return (
    <StyledIcon
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M10.6948 21.3896C9.21826 21.3896 7.83398 21.1094 6.54199 20.5488C5.25 19.9951 4.11182 19.2261 3.12744 18.2417C2.1499 17.2642 1.38428 16.1328 0.830566 14.8477C0.276855 13.5557 0 12.1714 0 10.6948C0 9.21826 0.276855 7.83398 0.830566 6.54199C1.38428 5.25 2.1499 4.11523 3.12744 3.1377C4.11182 2.15332 5.25 1.38428 6.54199 0.830566C7.83398 0.276855 9.21826 0 10.6948 0C12.1714 0 13.5557 0.276855 14.8477 0.830566C16.1396 1.38428 17.2744 2.15332 18.252 3.1377C19.2295 4.11523 19.9951 5.25 20.5488 6.54199C21.1094 7.83398 21.3896 9.21826 21.3896 10.6948C21.3896 12.1714 21.1094 13.5557 20.5488 14.8477C19.9951 16.1328 19.2295 17.2642 18.252 18.2417C17.2744 19.2261 16.1396 19.9951 14.8477 20.5488C13.5557 21.1094 12.1714 21.3896 10.6948 21.3896ZM8.28516 15.9653C8.44922 16.1294 8.6748 16.208 8.96191 16.2012C9.24902 16.1943 9.48145 16.1055 9.65918 15.9346L13.9556 11.9048C14.188 11.6929 14.3418 11.4399 14.417 11.146C14.4922 10.8521 14.4922 10.5615 14.417 10.2744C14.3418 9.98047 14.188 9.72412 13.9556 9.50537L9.65918 5.49609C9.46094 5.30469 9.23193 5.20557 8.97217 5.19873C8.7124 5.19189 8.49023 5.27734 8.30566 5.45508C8.10059 5.64648 7.99463 5.88232 7.98779 6.1626C7.98779 6.43604 8.08691 6.66504 8.28516 6.84961L12.4072 10.7051L8.28516 14.5708C8.09375 14.7554 7.99463 14.9844 7.98779 15.2578C7.98096 15.5244 8.08008 15.7603 8.28516 15.9653Z"
        fill="currentColor"
      />
    </StyledIcon>
  )
}
